import { useState } from "react";
import { FaMoneyCheck } from "react-icons/fa";
import { FaMoneyBillTransfer, FaPix } from "react-icons/fa6";
import { GiReceiveMoney, GiTakeMyMoney } from "react-icons/gi";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import { TbCurrencyReal, TbReportMoney } from "react-icons/tb";
import { useNavigate } from "react-router-dom";

export const useHome = () => {
    const [typeProductSelected, setTypeProductSelected] = useState("INSS");
    const navigate = useNavigate();

    const typeProducts = [
        {
            icon: TbCurrencyReal,
            title: "Empréstimo Consignado",
            description: "Modalidade de crédito para aposentados e pensionistas do INSS.",
            tag: "INSS",
            bullets: [
                "Até 96 parcelas",
                "A partir de R$100,00",
                "Taxas de 1,61% até 1,85%",
            ],
            action: "Simule agora"
        },
        {
            icon: FaMoneyBillTransfer,
            title: "Portabilidade de Consignado",
            description: "Transfira seu consignado para a meutudo e tenha a oportunidade de um troco.",
            tag: "INSS",
            bullets: [
                "Até 96 parcelas",
                "Faça com 0 parcelas pagas",
                "Taxas de 1,55% até 1,85%",
            ],
            action: "Simule agora"
        },
        {
            icon: RiMoneyDollarCircleLine,
            title: "Refinanciamento de Consignado",
            description: "Possibilidade de renegociar um empréstimo antigo por um novo.",
            tag: "INSS",
            bullets: [
                "Até 96 parcelas",
                "Possibilidade de troco",
                "Taxas de 1,51% até 1,85%",
            ],
            action: "Simule agora"
        },
        {
            icon: FaMoneyCheck,
            title: "Cartão de Crédito Consignado",
            description: "Cartão de crédito sem anuidade para aposentados e pensionistas do INSS.",
            tag: "INSS",
            bullets: [
                "Transforme seu limite em Pix",
                "Cashback",
                "Taxa de 2,46%",
            ],
            action: "Simule agora"
        },
        {
            icon: FaMoneyCheck,
            title: "Cartão Benefício INSS",
            description: "Cartão de crédito sem anuidade para aposentados e pensionistas do INSS.",
            tag: "INSS",
            bullets: [
                "Transforme seu limite em Pix",
                "Cashback",
                "Taxa de 2,46%",
            ],
            action: "Simule agora"
        },
        {
            icon: GiReceiveMoney,
            title: "Saque FGTS",
            description: "Permite ao trabalhador antecipar as parcelas do Saque-Aniversário do FGTS.",
            tag: "FGTS",
            bullets: [
                "Até 12 parcelas",
                "A partir de R$500,00",
                "Taxa de 1,29% a 1,79%",
            ],
            action: "Simule agora"
        },
        {
            icon: TbReportMoney,
            title: "Seguro Renda Protegida",
            description: "Proteção de renda para quem contrata o Saque Aniversário FGTS",
            tag: "SEGUROS",
            bullets: [
                "Receba o mesmo valor antecipado em caso de perda de emprego ou renda",
                "Pagamento único",
                "Cobertura para invalidez e morte por acidente",
            ],
            action: "Simule agora"
        },
        {
            icon: TbReportMoney,
            title: "Seguro de Vida",
            description: "Segurança financeira para você e para quem mais importa.",
            tag: "SEGUROS",
            bullets: [
                "Cobertura de dias de internação por acidente",
                "Contratação online",
                "Cobertura para morte natural ou acidental e invalidez por acidente",
            ],
            action: "Simule agora"
        }
    ];

    const getSubHeader = () => (<section style={{ zIndex: 5 }} className="hidden md:flex bg-[#462A71] w-full px-4 py-2 flex items-center justify-center gap-5 fixed">
        <a href="#ProductsCredt" className="text-white hover:opacity-[0.7] text-sm">Seu crédito seguro e personalizado</a>
        <a href="#HowSolicitationConsignadoINSS" className="text-white hover:opacity-[0.7] text-sm">como obter seu Empréstimo Consignado</a>
        <a href="#HowAnticipateFgts" className="text-white hover:opacity-[0.7] text-sm">Como antecipar meu Saque-Aniversário?</a>
        <a href="#CreditCard" className="text-white hover:opacity-[0.7] text-sm">Confira os benefícios em ter os dois cartões</a>
        <a href="#AdvantagesOfWithdrawal" className="text-white hover:opacity-[0.7] text-sm">Vantagens do saque no cartões</a>
        <a href="#WhyWithdraw" className="text-white hover:opacity-[0.7] text-sm">Por que sacar o limite do cartão?</a>
        <a href="#BmgMedPlans" className="text-white hover:opacity-[0.7] text-sm">Planos Bmg Med</a>
        <a href="#WhatIsFamilyLifeInsurance" className="text-white hover:opacity-[0.7] text-sm">O que é o Seguro Vida Familiar?</a>
    </section>)

    const onGoToRegister = () => navigate('/register');

    return {
        typeProducts,
        setTypeProductSelected,
        typeProductSelected,
        getSubHeader,
        onGoToRegister
    };
}